import { http } from '../request'
import { normalizeListResponse } from './shared'

export interface DepartmentDto {
  id: number
  name: string
  parentId?: number | null
  headId?: number | null
  headName?: string
  memberCount?: number
  sort?: number
}

export const departmentApi = {
  async list(): Promise<DepartmentDto[]> {
    const response = await http.get<DepartmentDto[]>('/organization/departments')
    return normalizeListResponse<DepartmentDto>(response.data)
  },
  async create(payload: Partial<DepartmentDto>): Promise<DepartmentDto> {
    const response = await http.post<DepartmentDto>('/organization/departments', payload)
    return response.data
  },
  async update(id: number, payload: Partial<DepartmentDto>): Promise<DepartmentDto> {
    const response = await http.put<DepartmentDto>(`/organization/departments/${id}`, payload)
    return response.data
  },
  async remove(id: number): Promise<void> {
    await http.delete<void>(`/organization/departments/${id}`)
  }
}
